(() => {
  const script = document.currentScript;
  const name = (new URLSearchParams(window.location.search).get('promo') || '')
    .replace(/[\u0000-\u001f\u007f]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, 300)
    .trim();
  const heading = document.querySelector('.vg-ended-card h1');
  if (!name || !heading || !script) return;
  heading.textContent = name;
  heading.style.overflowWrap = 'anywhere';
  document.title = script.dataset.titleTemplate.replace('__PROMO_NAME__', () => name)
    + ' – ' + script.dataset.shopName;
})();
